import React from 'react';
import styled from 'styled-components';
import { Tooltip } from '@block-explorer/ui';
import { HistoryLink } from '../../../components';
import { formatHash, HashLength } from '@make-software/cspr-design';
import { buildRouterPath } from '../../../router/utils';
import { NFT_TOKEN_PATH } from '../../../router/paths';
import { useTranslation } from 'react-i18next';

const TokenWrapper = styled.div(({ theme }) => ({
  padding: '2px 8px',
  borderRadius: '4px',
  backgroundColor: theme.styleguideColors.fillSecondary,
}));

const MIN_TRUNCATE_HASH_LENGTH = HashLength.TINY * 2 + 3;

export const NftTokenId = ({ token_id, path }) => {
  const { t } = useTranslation();
  const tokenIdContent = (
    <TokenWrapper key={`token-${token_id}`}>
      <HistoryLink href={path} ariaDescription={'Link to nft token details'}>
        {formatHash(token_id.toString(), HashLength.LITTLE)}
      </HistoryLink>
    </TokenWrapper>
  );

  return token_id.length > MIN_TRUNCATE_HASH_LENGTH ? (
    <Tooltip tooltipContent={token_id} caption={t('Token ID')}>
      {tokenIdContent}
    </Tooltip>
  ) : (
    tokenIdContent
  );
};

export const NftTokenIds = ({
  nftTokenIds,
  collectionHash,
}: {
  nftTokenIds: string[] | undefined | null;
  collectionHash: string;
}) => {
  const getNftPath = (collectionHash: string, nftId: string) =>
    buildRouterPath(
      NFT_TOKEN_PATH,
      { contract_package_hash: collectionHash, token_id: nftId },
      undefined
    );

  return (
    <>
      {nftTokenIds
        ? nftTokenIds.map((nftId) => (
            <NftTokenId
              token_id={nftId}
              key={nftId}
              path={getNftPath(collectionHash, nftId)}
            />
          ))
        : null}
    </>
  );
};
